const APIs = {
  SUBSCRIPTIONS: 'admin/subscriptions',
  SINGLE_SUBSCRIPTION: 'admin/subscriptions/:id',
}

export default APIs
